import { render, staticRenderFns } from "./Component-VideoMonitor.vue?vue&type=template&id=bafebf12&scoped=true"
import script from "./Component-VideoMonitor.vue?vue&type=script&lang=js"
export * from "./Component-VideoMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafebf12",
  null
  
)

export default component.exports